import { useUniqueId } from "@hornet-web-react/core/utils"
import {
  ToggleContainer,
  ToggleContent,
  ToggleInput,
  ToggleLabel,
  ToggleLabelContainer,
  Wrapper,
} from "./ToggleV3.styles"
import { FormEvent, ReactNode } from "react"

type ToggleV3Props = {
  className?: string
  name: string
  label: ReactNode
  placeholder?: string
  onChange: (
    isChecked: boolean,
    name: string,
    event: FormEvent<HTMLInputElement>
  ) => void
  value: boolean
}

export default function ToggleV3({
  className,
  name,
  value,
  label,
  onChange,
}: ToggleV3Props) {
  const inputUniqueId = useUniqueId(name)

  const onInput = (e: FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.checked, e.currentTarget.name, e)
  }

  return (
    <Wrapper className={className}>
      <ToggleContainer hasError={false}>
        {label && <ToggleLabelContainer>{label}</ToggleLabelContainer>}
        <div>
          <ToggleContent>
            <ToggleInput
              name={name}
              checked={value}
              onChange={onInput}
              id={inputUniqueId}
              type="checkbox"
            />
            <ToggleLabel htmlFor={inputUniqueId} />
          </ToggleContent>
        </div>
      </ToggleContainer>
    </Wrapper>
  )
}
